module.exports = __webpack_public_path__ + "img/checkBox.6bb1e162.svg";